// extracted by mini-css-extract-plugin
export default {"header":"Header_header__BKh8b","header__inner":"Header_header__inner__SV+Nr","header__right":"Header_header__right__XwJxl","header__menu":"Header_header__menu__nMtHx"};